export default __webpack_public_path__ + "static/media/undraw_empty_card.c2866162.svg";